import type { LlmAdapter } from "../types.js";

export interface GeminiAdapterOptions {
  apiKey?: string;
  model?: string;
}

export class GeminiAdapter implements LlmAdapter {
  private apiKey: string;
  private model: string;

  constructor(options: GeminiAdapterOptions = {}) {
    this.apiKey = options.apiKey ?? process.env.GEMINI_API_KEY ?? "";
    this.model = options.model ?? "gemini-2.5-flash";
    if (!this.apiKey) {
      throw new Error(
        "GEMINI_API_KEY environment variable is required for the gemini adapter.",
      );
    }
  }

  async analyze(prompt: string): Promise<string> {
    const { GoogleGenAI } = (await import("@google/genai")) as {
      GoogleGenAI: new (opts: { apiKey: string }) => GenAIClient;
    };
    const client = new GoogleGenAI({ apiKey: this.apiKey });
    const response = await client.models.generateContent({
      model: this.model,
      contents: prompt,
    });
    return response.text ?? "";
  }
}

interface GenAIClient {
  models: {
    generateContent(opts: {
      model: string;
      contents: string;
    }): Promise<{ text?: string }>;
  };
}
